<template>
  <div class="page_box">
    <full-loading :fullLoadingShow="fullLoadingShow"></full-loading>
    <div class="page_bg">
      <img class="bg_img" src="@assets/paycost/images/page_bg.png" />
      <div class="pay_body">
        <!-- 主体 -->
        <div class="pay_success">
          <span>
            <img src="@assets/paycost/images/pay_succ.png" />
          </span>
          <span class="succ_txt">会员信息补全</span>
        </div>
        <div class="pay_pessage">
          <!--                    <p>您已成功缴费,可直接驶离停车场</p>-->
          <div>
            <span class="span_btn" @click="toHistory">欠费补缴</span>
            <span class="span_btn" @click="toHome">返回首页</span>
          </div>
        </div>
        <div class="pay_message">
          <div class="mes_t">
            <h2>
              <span><img src="@assets/paycost/images/title_l.png" /></span
              >满足以下条件可先驶离后付费<span
                ><img src="@assets/paycost/images/title_r.png"
              /></span>
            </h2>
            <img class="t_line" src="@assets/paycost/images/t_line.png" />
          </div>
          <ul class="pay_list">
            <li>
              <div class="icon">
                <img src="@assets/paycost/images/wechat.png" />
              </div>
              <div class="list_txt">
                <div>
                  <div class="list_l">
                    <h2>关注微信公众号</h2>
                    <p>接收进出场相关通知</p>
                  </div>
                  <div class="list_btn">
                    <van-button
                      class="btn"
                      round
                      v-if="!wxfocus"
                      @click="toFocusWx"
                      >去关注
                    </van-button>
                    <van-button class="unbtn" round disabled v-else
                      >已关注</van-button
                    >
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="icon">
                <img src="@assets/paycost/images/car.png" />
              </div>
              <div class="list_txt">
                <div>
                  <div class="list_l">
                    <h2>绑定车辆</h2>
                    <p>接收进出场相关通知</p>
                  </div>
                  <div class="list_btn">
                    <van-button
                      class="btn"
                      round
                      v-if="!carbind"
                      @click="toBindCar"
                      >去绑定
                    </van-button>
                    <van-button class="unbtn" round disabled v-else
                      >已绑定</van-button
                    >
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="icon">
                <img src="@assets/paycost/images/phone.png" />
              </div>
              <div class="list_txt">
                <div>
                  <div class="list_l">
                    <h2>绑定手机</h2>
                    <p>您的个人资料暂未绑定手机</p>
                  </div>
                  <div class="list_btn">
                    <van-button
                      class="btn"
                      round
                      v-if="!bindphone"
                      @click="toBindPhone"
                      >去绑定
                    </van-button>
                    <van-button class="unbtn" round disabled v-else
                      >已绑定</van-button
                    >
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="icon">
                <img src="@assets/paycost/images/money.png" />
              </div>
              <div class="list_txt">
                <div>
                  <div class="list_l" v-if="owemoney > 0">
                    <h2>欠费补缴</h2>
                    <p>
                      您已停车欠费<span>{{ owemoney }}元</span>
                    </p>
                  </div>
                  <div class="list_l" v-else>
                    <h2>欠费补缴</h2>
                    <p>暂无欠费信息</p>
                  </div>
                  <div class="list_btn">
                    <van-button
                      class="btn"
                      round
                      v-if="owemoney > 0"
                      @click="toPay"
                      >去补缴</van-button
                    >
                    <van-button class="unbtn" round disabled v-else
                      >无欠费</van-button
                    >
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- 主体end -->
        <!-- 手机绑定弹窗 -->
        <div class="pop_box" v-if="popShow">
          <div class="phone_pop">
            <van-icon
              name="cross"
              size="20px"
              class="popclose"
              @click="popClose"
            />
            <h2>温馨提示</h2>
            <p>为了您的正常使用,请绑定手机</p>
            <div class="phone_input">
              <input
                v-model="phoneNum"
                class="phone-num"
                type="text"
                placeholder="请输入手机号码"
              />
            </div>
            <div class="verify_input">
              <input
                class="verify-num"
                v-model="verifyNum"
                type="text"
                placeholder="请输入验证码"
              />
              <input
                @click="sendSmsCode"
                class="verify-btn"
                type="button"
                v-model="btnContent"
                :disabled="disabled"
                :class="{ disable: disabled }"
              />
            </div>
            <input
              class="submit-confirm"
              @click.stop="verificationCode"
              type="button"
              value="绑定"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
import { Notify } from "vant";

export default {
  name: "PayCost",
  components: {},
  data() {
    return {
      fullLoadingShow: true,
      wxfocus: true, //是否已关注公众号
      carbind: true, //是否已绑定车辆
      bindphone: true, //是否已绑定手机
      owepay: true, //是否欠费
      owemoney: 0, //已欠费
      popShow: false,
      phoneNum: "", //手机号
      verifyNum: "", //验证码
      btnContent: "获取验证码", //获取验证码按钮内文字
      time: 60, //发送验证码间隔时间
      disabled: false, //按钮状态
      toPayCarNumber: "",
    };
  },
  created() {
    this.$apis
      .getCarBindStatus({ carNumber: this.$route.query.carNumber })
      .then((res) => {
        this.fullLoadingShow  = false;
        if (res.code === 200) {
          this.toPayCarNumber = res.data.car_number;
          this.owemoney = res.data.money;
          this.carbind = res.data.carbind;
          this.bindphone = res.data.bindphone;
          this.owepay = res.data.owepay;
        } else {
          this.wxfocus = false;
          this.carbind = false;
          this.bindphone = false;
          this.owepay = false;
        }
      });
  },

  methods: {
    popClose() {
      this.popShow = false;
    },
    timer() {
      if (this.time > 0) {
        this.time--;
        this.btnContent = this.time + "s后重新获取";
        this.disabled = true;
        var timer = setTimeout(this.timer, 1000);
      } else if (this.time == 0) {
        this.btnContent = "获取验证码";
        clearTimeout(timer);
        this.disabled = false;
      }
    },
    sendSmsCode() {
      let reg = /^[1][3,4,5,7,8][0-9]{9}$/; //手机号正则验证
      let phoneNum = this.phoneNum;
      if (!phoneNum) {
        //未输入手机号
        Toast.fail("请输入手机号码");
        return;
      }
      if (!reg.test(phoneNum)) {
        //手机号不合法
        Toast.fail("请输入正确的手机号");
        return;
      }
      this.time = 60;
      this.timer();
      // 获取验证码请求
      // let url = '';
      // this.$http.post(url, { username: phoneNum }, { emulateJSON: true }).then(response => {
      // 	console.log(response.body);
      // })
      this.$apis
        .sendSms({ phone_number: phoneNum, event: "change_phone" })
        .then((res) => {
          if (res.code == 200 && res.msg == "发送成功") {
            setTimeout(function () {
              Notify({ type: "success", message: "验证码已发送" });
            }, 1000);
          } else {
            setTimeout(function () {
              Notify({ type: "success", message: res.msg });
            }, 1000);
          }
        });
    },
    verificationCode() {
      //绑定按钮点击
      let reg = /^[1][3,4,5,7,8][0-9]{9}$/; //手机号正则验证
      let phoneNum = this.phoneNum;
      let verifyNum = this.verifyNum;
      if (!phoneNum) {
        Toast.fail("请输入手机号码");
        return false;
      }
      if (!verifyNum) {
        Toast.fail("请输入验证码");
        return false;
      }
      if (!reg.test(phoneNum)) {
        Toast.fail("请输入正确的手机号");
        return;
      }
      let _that = this;
      this.$apis
        .bindPhone({ phone_number: phoneNum, phone_code: verifyNum })
        .then((res) => {
          if (res.code == 200) {
            setTimeout(function () {
              Notify({ type: "success", message: "绑定成功" });
              _that.popShow = false;
              _that.bindphone = true;
            }, 1000);
          } else {
            setTimeout(function () {
              Notify({ type: "success", message: "绑定失败" });
            }, 1000);
          }
        });
    },
    toHome() {
      this.$router.push("/index");
    },
    toHistory() {
      this.$router.push("/payBack");
    },
    toFocusWx() {
      this.$router.push("/parkingQr");
    },
    toBindCar() {
      this.$router.push("/carManage");
    },
    toBindPhone() {
      this.popShow = true;
    },
    toPay() {
      let carNumber;
      if (this.$route.query.carNumber) {
        carNumber = this.$route.query.carNumber;
      } else {
        carNumber = this.toPayCarNumber;
      }
      this.$router.push({ path: "/findArrears", query: { carNum: carNumber } });
    },
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

.page_bg {
  width: 100%;
  position: relative;
}

.page_bg .bg_img {
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  z-index: 1;
}

.pay_success {
  display: flex;
  width: 100%;
  justify-content: center;
  padding: 1rem 0 20px 0;
  align-items: center;
}

.pay_body {
  position: relative;
  z-index: 2;
}

.pay_success .succ_txt {
  margin-left: 15px;
  color: #fff;
  font-size: 20px;
  letter-spacing: 1px;
}

.pay_success span img {
  height: 35px;
  vertical-align: middle;
}

.pay_pessage p {
  text-align: center;
  color: #fff;
  font-size: 15px;
  padding: 0 0 20px 0;
  margin: 0;
}

.pay_pessage .span_btn {
  display: inline-block;
  padding: 0 .42rem;
  height: .7rem;
  line-height: .7rem;
  border: 1px solid #fff;
  color: #fff;
  font-size:.26rem;
  border-radius: .7rem;
  text-align: center;
  margin: 0 .28rem;
}

.pay_pessage {
  text-align: center;
}

.pay_message {
  background: #fff;
  margin: 20px 20px 35px 20px;
  padding: 25px 15px 0 15px;
  border-radius: 15px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
}

.mes_t {
  text-align: center;
}

.mes_t h2 {
  font-size: 16px;
  font-weight: normal;
  position: relative;
}

.mes_t h2 span {
  display: inline-block;
  height: 15px;
  margin: 0 5px;
  vertical-align: -2px;
}

.mes_t h2 span img {
  height: 15px;
}

.mes_t .t_line {
  margin-top: 25px;
  width: 100%;
  margin-bottom: 20px;
}

.pay_list {
  height: auto;
  overflow: hidden;
}

.pay_list li .icon {
  float: left;
  height: 1.45rem;
  width: .78rem;
  display: flex;
  align-items: center;
}

.pay_list li .icon img {
  width: .7rem;
}

.list_txt {
  height: 1.45rem;
  margin-left: .9rem;
}

.list_l h2 {
  font-size: .3rem;
  font-weight: normal;
  margin-bottom: 2px;
}

.list_l p {
  font-size: .22rem;
  color: #9b9b9b;
}

.list_txt > div {
  height: 1.45rem;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
}

.pay_list li .list_btn {
  height: 1.45rem;
  display: flex;
  align-items: center;
}

.list_l {
  height: 1.45rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.list_btn .btn {
  background: #ff8f2f;
  color: #fff;
  padding: 0 10px;
  height: .6rem;
  line-height: .6rem;
  border: 1px solid #ff8f2f;
  font-size: .26rem;
  width: 1.5rem;
}
.list_btn .unbtn {
  background: #fff;
  color: #ff8500;
  padding: 0 10px;
  height:.6rem;
  line-height: .6rem;
  border: 1px solid #ff8500;
  font-size: .26rem;
  width: 1.5rem;
  opacity: 1 !important;
}
.pay_list li:last-child .list_txt > div {
  border-bottom: none;
}
.phone_pop {
  border-radius: 5px;
  width: 85%;
  padding: 25px 20px;
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
}
.phone_pop h2 {
  text-align: center;
  font-weight: normal;
  font-size: 16px;
  text-align: center;
  margin-bottom: 10px;
}
.phone_pop p {
  font-size: 13px;
  text-align: center;
  margin-bottom: 25px;
}
.phone_input input {
  width: 100%;
  border: none;
  margin-bottom: 5px;
  padding: 0px 6px 3px 6px;
  box-sizing: border-box;
  font-size: 14px;
  color: #999;
}
.phone_input {
  border-bottom: 1px solid #eee;
}
.phone_input input::-webkit-input-placeholder {
  color: #999;
  font-size: 13px;
}
.van-popup__close-icon--top-right {
  top: 8px !important;
  right: 8px !important;
}
.verify_input {
  position: relative;
  height: 45px;
  overflow: hidden;
  margin-bottom: 5px;
  border-bottom: 1px solid #eee;
  margin-top: 8px;
}
.verify_input .verify-btn {
  position: absolute;
  right: 0;
  bottom: 8px;
  width: 100px;
  display: inline-block;
  background: #ff8f2f;
  border: none;
  color: #fff;
  font-size: 13px;
  height: 30px;
  border-radius: 5px;
  box-sizing: border-box;
  outline: 0px;
  -webkit-appearance: none;
}
.verify_input .verify-num {
  position: absolute;
  border: none;
  box-sizing: border-box;
  border: none;
  padding: 5px 6px 0 6px;
  box-sizing: border-box;
  right: 110px;
  bottom: 8px;
  left: 0;
  font-size: 14px;
  color: #999;
}
.verify_input .verify-num::-webkit-input-placeholder {
  color: #999;
  font-size: 13px;
}
.pop_box {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2000;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
}
.popclose {
  position: absolute !important;
  right: 8px;
  top: 8px;
  color: #666;
}
.submit-confirm {
  width: 100%;
  height: 35px;
  line-height: 35px;
  outline: 0px;
  -webkit-appearance: none;
  background: #ff8f2f;
  border: none;
  outline: none;
  color: #fff;
  font-size: 14px;
  letter-spacing: 8px;
  border-radius: 4px;
  margin-top: 8px;
}
.verify_input .verify-btn.disable {
  background: #e7e6e6;
  color: #999;
}

@media (max-width: 350px) {
  .list_l h2 {
    font-size: 14px;
  }
  .list_l p {
    font-size: 12px;
  }
  .list_btn .unbtn,
  .list_btn .btn {
    height: 30px;
    line-height: 32px;
    font-size: 13px;
    padding: 0 15px;
    width: 84px;
  }
  .mes_t h2 {
    font-size: 15px;
  }
  .mes_t .t_line {
    margin-top: 15px;
    margin-bottom: 10px;
  }
  .mes_t h2 span img {
    height: 12px;
  }
  .mes_t h2 span {
    vertical-align: 0;
  }
  .pay_success span img {
    height: 30px;
  }
  .pay_success .succ_txt {
    font-size: 17px;
  }
  .pay_pessage p {
    font-size: 14px;
  }
  .pay_success {
    pad: 25px 0 15px 0;
  }
  .pay_pessage .span_btn {
    height: 30px;
    line-height: 32px;
    font-size: 13px;
    padding: 0 15px;
    margin: 0 18px;
  }
  .list_txt {
    margin-left: 50px;
  }
  .pay_message {
    background: #fff;
    padding: .26rem .22rem 0 .22rem;
  }
  .pay_list li .icon img {
    width: 35px;
  }
}
</style>
